var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9844 13.25C11.3634 13.25 10.8594 12.914 10.8594 12.5V7.25C10.8594 6.836 11.3634 6.5 11.9844 6.5C12.6054 6.5 13.1094 6.836 13.1094 7.25V12.5C13.1094 12.914 12.6054 13.25 11.9844 13.25Z",
    fill: "#CC0018"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9922 17.75C12.8206 17.75 13.4922 17.0784 13.4922 16.25C13.4922 15.4216 12.8206 14.75 11.9922 14.75C11.1638 14.75 10.4922 15.4216 10.4922 16.25C10.4922 17.0784 11.1638 17.75 11.9922 17.75Z",
    fill: "#CC0018"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 12.5C22.125 18.0919 17.5919 22.625 12 22.625C6.40812 22.625 1.875 18.0919 1.875 12.5C1.875 6.90812 6.40812 2.375 12 2.375C17.5919 2.375 22.125 6.90812 22.125 12.5Z",
    stroke: "#CC0018",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon2);
export default __webpack_public_path__ + "static/media/error-icon2.68c1d8cb380a9aaedf884e91c7852629.svg";
export { ForwardRef as ReactComponent };